import { Card, Heading } from '@expressable/syntax-ds';
import { Icon } from 'components/Icon';
import quotesImg from 'assets/images/signup/quotes.png';
import { useTranslation } from 'react-i18next';

export const ReviewsCard = () => {
  const { t } = useTranslation();
  return (
    <Card className="bg-yellow-texture min-h-e128 bg-cover gap-e24 mobile:p-e64 flex flex-col">
      <img alt="" srcSet={quotesImg} className="size-e56" />
      <Heading level="h3" noDefaultMargins>
        {t('directSignup.footer.1')}
      </Heading>
      <div className="flex justify-between w-full">
        <div className="flex gap-e4">
          <Icon name="Star" />
          <Icon name="Star" />
          <Icon name="Star" />
          <Icon name="Star" />
          <Icon name="Star" />
        </div>
        <span>{t('directSignup.footer.exampleClient')}</span>
      </div>
    </Card>
  );
};
